import { useEffect, useState } from "react";
import DashboardLayout, { StatCard, EmptyState } from "./DashboardLayout";
import { LayoutDashboard, Users, ClipboardCheck, GraduationCap } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

const NAV = [
    { key: "overview", label: "Dashboard", icon: LayoutDashboard },
    { key: "students", label: "Students", icon: Users },
    { key: "grading", label: "Grading Queue", icon: ClipboardCheck },
];

export default function TeacherDashboard() {
    const [tab, setTab] = useState("overview");
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/teacher/dashboard").then((r) => setData(r.data)).catch(() => setData({})); }, []);
    if (!data) return <DashboardLayout nav={NAV} active={tab} onNav={setTab} title="Teacher Dashboard"><div className="grid place-items-center py-20"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div></DashboardLayout>;

    return (
        <DashboardLayout nav={NAV} active={tab} onNav={setTab} title="Teacher Dashboard">
            {tab === "overview" && (
                <div className="space-y-6">
                    <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
                        <StatCard icon={GraduationCap} label="Active Classes" value={(data.classes || []).length} />
                        <StatCard icon={Users} label="Students" value={(data.students || []).length} color="accent" />
                        <StatCard icon={ClipboardCheck} label="To Grade" value={(data.submissions || []).length} color="success" />
                    </div>
                    <Card className="p-6">
                        <h3 className="font-heading font-bold mb-4">Your Classes</h3>
                        <div className="space-y-3">
                            {(data.classes || []).map((c) => (
                                <div key={c.name} className="flex items-center justify-between rounded-xl border border-border p-4">
                                    <div><p className="font-medium">{c.name}</p><p className="text-sm text-foreground/50">{c.schedule}</p></div>
                                    <Badge variant="secondary" className="rounded-full">{c.students} students</Badge>
                                </div>
                            ))}
                        </div>
                    </Card>
                </div>
            )}
            {tab === "students" && (
                <Card className="p-0 overflow-hidden">
                    <Table>
                        <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Email</TableHead><TableHead>Role</TableHead></TableRow></TableHeader>
                        <TableBody>
                            {(data.students || []).map((s) => <TableRow key={s.id}><TableCell className="font-medium">{s.name}</TableCell><TableCell className="text-foreground/60">{s.email}</TableCell><TableCell><Badge variant="secondary" className="rounded-full capitalize">{s.role}</Badge></TableCell></TableRow>)}
                        </TableBody>
                    </Table>
                </Card>
            )}
            {tab === "grading" && (
                <div className="space-y-3">
                    {(data.submissions || []).length ? data.submissions.map((p) => (
                        <Card key={p.id} className="p-5 flex items-center justify-between"><div><p className="font-heading font-bold">{p.title}</p><p className="text-sm text-foreground/50">{p.scenario}</p></div><Badge className="bg-accent/15 text-accent border-0">{p.status}</Badge></Card>
                    )) : <EmptyState icon={ClipboardCheck} title="Nothing to grade" desc="Submissions awaiting review will show here." />}
                </div>
            )}
        </DashboardLayout>
    );
}
